import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import './AuthLayout.css';

/* True when this window was opened by the app rather than navigated to — a
 * table popped out into its own browser window.
 *
 * Detected from window.opener rather than a route or a query parameter: it
 * needs no URL scheme, cannot be reached by bookmarking, and is exactly the
 * question being asked. A popped-out table is one table filling one window,
 * so the app header and its 64px of padding are only in the way.
 */
export function isPoppedOut() {
  try {
    return typeof window !== 'undefined' && !!window.opener && !window.opener.closed;
  } catch {
    // A cross-origin opener throws on .closed; still an opener either way.
    return typeof window !== 'undefined' && !!window.opener;
  }
}

export default function AuthLayout() {
  const { user, loading } = useAuth();
  const popped = isPoppedOut();

  if (loading) return null;
  if (!user)   return <Navigate to="/login" replace />;

  return (
    <>
      {!popped && <Header />}
      <main className={`auth-main ${popped ? 'popped' : ''}`}>
        <Outlet />
      </main>
    </>
  );
}
